import { render, staticRenderFns } from "./UiPopover.vue?vue&type=template&id=6ad23e30"
import script from "./UiPopover.vue?vue&type=script&lang=js"
export * from "./UiPopover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports